import { throttle } from 'lodash-es';
import { useRef, useEffect } from 'react';

import { getScrollableContainer } from '../../../../utils/helpers';

const mainScrollableContainer = getScrollableContainer();

function useShowMiniHeader(offset = 210) {
  const scrollRef = useRef();

  useEffect(() => {
    const handleScroll = throttle(({ target }) => {
      const scrollTop = mainScrollableContainer === window ? window.scrollY : target.scrollTop;
      if (scrollRef.current) {
        if (scrollTop > offset) scrollRef.current.classList.add('shadow');
        else scrollRef.current.classList.remove('shadow');
      }
    }, 100);

    mainScrollableContainer.addEventListener('scroll', handleScroll);

    return () => {
      mainScrollableContainer.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return scrollRef;
}

export default useShowMiniHeader;
